module.exports = __webpack_public_path__ + "img/GOV_CE_LOGO.c6786107.svg";